import {Observable, of as observableOf} from 'rxjs';

import {map} from 'rxjs/operators';
import {Pipe, PipeTransform} from '@angular/core';
import {LanguageService} from '../../language/language.service';
import {CacheService} from '../../cache/cache.service';
import moment from 'moment-timezone';
import 'moment/min/locales.js';

@Pipe({
  name: 'localDate',
  standalone: false,
})
export class LocalDatePipe implements PipeTransform {
  constructor(private cacheService: CacheService) {}

  transform(value: any, format?: string, useTimeZone = true): Observable<string> {
    if (!value) return observableOf('');
    if (!format) format = 'L LTS';

    let lang = LanguageService.getBrowserLanguage();

    if (useTimeZone) {
      return this.cacheService.getTimeZone().pipe(
        map((tzName: string) => {
          return moment.utc(value).tz(tzName).locale(lang).format(format);
        }),
      );
    } else {
      return observableOf(moment(value).locale(lang).format(format));
    }
  }
}
